export default defineNuxtPlugin(async () => {
  for (const name of ["clocktracker-offline", "clocktracker-sync"]) indexedDB.deleteDatabase(name);
  localStorage.removeItem("ct-last-user");
  localStorage.removeItem("ct-feature-flags");
  if ("caches" in window) {
    for (const key of await caches.keys()) {
      if (key === "clocktracker-api-cache" || key === "supabase-cache") await caches.delete(key);
    }
  }
});
